export default {
  "ENV": "stage",
  "ENV_URL": "stg",
  "LOG_LEVEL": "3",
  "LOG_RESTRICT_TO_USERNAMES": "",
  "POSTHOG_API_KEY": "phc_WmmaRnqe9zHP3QmwA6qV53l3vZz7b9aZMGJqCi3Wcvp",
  "POSTHOG_DEBUG": "",
  "ROOMS_LIMIT": "1000",
  "TABLES_LIMIT": "1000",
  "CMS_URL": "https://graphql.contentful.com/content/v1/spaces/rrch712do7ep",
  "CMS_TOKEN": "cQcS2XOBgmc7xj-42jD1EQOtS6ZvHh6Jfv23c_ERbPg"
};